<script setup lang="ts">
import { computed } from "vue";
import type { TPracticeStaffBadge } from "@/api/models/practice/practiceStaff";

const props = withDefaults(
  defineProps<{
    badges?: TPracticeStaffBadge[];
    size?: string;
    showAll?: boolean;
  }>(),
  {
    badges: () => [],
    size: "x-small",
    showAll: false,
  }
);

const badgesToRender = computed(() => {
  const list = props.badges ?? [];
  if (props.showAll) return list;
  if (list.length === 0) return [];

  const best = list.reduce((acc, b) => (b.priority > acc.priority ? b : acc), list[0]!);
  return [best];
});
</script>

<template>
  <v-chip
    v-for="badge in badgesToRender"
    :key="badge.code"
    :size="size"
    :color="`#${badge.color}`"
    variant="flat"
    density="compact"
  >
    {{ badge.code }}
  </v-chip>
</template>
